import ko from 'knockout';
import template from './folderUploadsListItem.html';

export function FolderUploadListItemViewModel(params) {

  var self = this;

  self.folderUpload = params.folderUpload;
  self.isReadOnly = params.isReadOnly;

  self.isFilesListVisible = ko.observable(false);
  self.toggleFilesListVisibility = function () {
    self.isFilesListVisible(!self.isFilesListVisible());
  };

  self.removeUploadCallback = params.removeUploadCallback;
  self.removeUploads = function () {
    self.removeUploadCallback(self.folderUpload.uploads);
  };
}

// The default export returns the component details object to register with KO
export default { viewModel: FolderUploadListItemViewModel, template: template };
